'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const AccountsIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="AccountsIcon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke={sx?.color ? sx.color : '#273443'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2610_23667)">
          <path
            d="M0.504028 12C0.504028 15.05 1.71563 17.9751 3.8723 20.1317C6.02897 22.2884 8.95404 23.5 12.004 23.5C15.054 23.5 17.9791 22.2884 20.1358 20.1317C22.2924 17.9751 23.504 15.05 23.504 12C23.504 10.4898 23.2066 8.99438 22.6286 7.59914C22.0507 6.2039 21.2036 4.93615 20.1358 3.86827C19.0679 2.8004 17.8001 1.95331 16.4049 1.37539C15.0096 0.797456 13.5142 0.5 12.004 0.5C10.4938 0.5 8.99841 0.797456 7.60317 1.37539C6.20792 1.95331 4.94017 2.8004 3.8723 3.86827C2.80443 4.93615 1.95734 6.2039 1.37941 7.59914C0.801485 8.99438 0.504028 10.4898 0.504028 12Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M8.00403 11.5H13.004" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M14.5 8.5C14.5 7.96957 14.2893 7.46086 13.9142 7.08579C13.5391 6.71071 13.0304 6.5 12.5 6.5C11.9696 6.5 11.4609 6.71071 11.0858 7.08579C10.7107 7.46086 10.5 7.96957 10.5 8.5V13C10.5 14.657 10.157 16.5 8.5 16.5H14.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2610_23667">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

AccountsIcon.propTypes = {
  sx: PropTypes.object
}
